// @mui
import {
  Stack,
  Grid,
  Button,
  Typography,
  Pagination,
  LinearProgress,
} from '@mui/material';
// hooks
import { Category } from 'src/@types/Category';
import { useEffect, useState } from 'react';
import CategoryCard from './CategoryCard';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import Iconify from 'src/components/Iconify';
import { UserTableToolbar } from 'src/sections/@dashboard/user/list';
import ConfirmationDialog from '../../shared/ConfirmationDialog';
import { useCategories } from '../useCategories';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { CategoryModal } from './CategoryModal';

// ----------------------------------------------------------------------
const Sort_Options = ['all', 'acsending', 'descending'];

// ----------------------------------------------------------------------

export default function CategoryList() {
  const {
    modalOpen,
    setModalOpen,
    filterName,
    filterRole,
    currentCategory,
    setCurrentCategory,
    filteredData,
    page,
    setPage,
    total,
    pageSize,
    loading,
    handleDeleteRow,
    handleEditRow,
    handleFilterName,
    getCategoryList,
  } = useCategories();

  // client-side-pagination-list-pages: refetch on page/search change (search
  // debounced 350ms; page changes immediate).
  useEffect(() => {
    const t = setTimeout(() => getCategoryList().catch(console.error), filterName ? 350 : 0);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, filterName]);

  const [confirmOpen, setConfirmOpen] = useState({ open: false, currentId: '' });

  return (
    <Stack>
      <HeaderBreadcrumbs
        heading="Path List"
        links={[
          { name: 'Dashboard', href: PATH_DASHBOARD.root },
          { name: 'Path List', href: PATH_DASHBOARD.categories },
        ]}
        action={
          <Button
            variant="contained"
            onClick={() => setModalOpen(true)}
            startIcon={<Iconify icon={'eva:plus-fill'} />}
          >
            New Path
          </Button>
        }
      />
      <UserTableToolbar
        small={true}
        placeholder="Search Paths..."
        filterName={filterName}
        filterRole={filterRole}
        onFilterName={handleFilterName}
        onFilterRole={() => {}}
        optionsRole={Sort_Options}
      />
      {loading && <LinearProgress sx={{ my: 1 }} />}
      <Grid container>
        {filteredData.map((category: Category, index: number) => (
          <Grid
            spacing={1}
            key={category._id}
            item
            xs={12}
            sm={6}
            md={4}
            lg={4}
            rowSpacing={1}
            columnSpacing={1}
          >
            <CategoryCard
              category={category}
              key={index}
              handleEditRow={() => handleEditRow(category)}
              handleDeleteRow={() =>
                setConfirmOpen({ open: true, currentId: category._id as string })
              }
            />
          </Grid>
        ))}
        {!loading && filteredData.length === 0 && (
          <Stack width={'100%'} height="300px" alignItems={'center'} justifyContent="center">
            <Typography> No result for your search data</Typography>
          </Stack>
        )}
      </Grid>
      {total > pageSize && (
        <Stack alignItems="center" sx={{ my: 3 }}>
          <Pagination
            count={Math.ceil(total / pageSize)}
            page={page}
            onChange={(_e, p) => setPage(p)}
            color="primary"
          />
        </Stack>
      )}
      <CategoryModal
        open={modalOpen}
        handleClose={() => {
          setModalOpen(false);
          getCategoryList();
          setCurrentCategory(undefined);
        }}
        isEdit={currentCategory ? true : false}
        currentCategory={currentCategory}
      />
      <ConfirmationDialog
        headText={'Delete Category'}
        text={'Are You Sure You Need To Delete This Category'}
        isOpen={confirmOpen.open}
        onClose={() => {
          setConfirmOpen({ open: false, currentId: '' });
          getCategoryList();
        }}
        confirmAction={() => handleDeleteRow(confirmOpen.currentId)}
        loading={false}
      />
    </Stack>
  );
}
